import React from 'react'
import { Redirect } from 'react-router-dom'

export function RedirectWithUpdatedGovernance() {
  return <Redirect to={'/delegates/uniswap'} />
}
